import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "content-builder" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { class: "input-group" };
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-6" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = {
    key: 0,
    class: "list-group my-4"
};
const _hoisted_13 = { class: "d-flex" };
const _hoisted_14 = { class: "col-3" };
const _hoisted_15 = ["src"];
const _hoisted_16 = ["for"];
const _hoisted_17 = { class: "input-group" };
const _hoisted_18 = { class: "input-group-prepend" };
const _hoisted_19 = ["data-input"];
const _hoisted_20 = ["id", "onUpdate:modelValue"];
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = ["id", "onUpdate:modelValue"];
const _hoisted_23 = ["for"];
const _hoisted_24 = { class: "col-9" };
const _hoisted_25 = ["for"];
const _hoisted_26 = ["id", "onUpdate:modelValue"];
const _hoisted_27 = {
    key: 0,
    class: "form-group"
};
const _hoisted_28 = ["for"];
const _hoisted_29 = ["for"];
const _hoisted_30 = ["id", "onUpdate:modelValue"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = { class: "form-group card-metrics" };
const _hoisted_34 = { class: "row d-flex align-items-center" };
const _hoisted_35 = { class: "col-10" };
const _hoisted_36 = { class: "row" };
const _hoisted_37 = { class: "col-sm" };
const _hoisted_38 = ["id", "onUpdate:modelValue"];
const _hoisted_39 = { class: "form-group card-metrics" };
const _hoisted_40 = { class: "row d-flex align-items-center" };
const _hoisted_41 = { class: "col-10" };
const _hoisted_42 = { class: "row" };
const _hoisted_43 = { class: "col-sm" };
const _hoisted_44 = ["id", "onUpdate:modelValue"];
const _hoisted_45 = { class: "form-group card-metrics" };
const _hoisted_46 = { class: "row d-flex align-items-center" };
const _hoisted_47 = { class: "col-10" };
const _hoisted_48 = { class: "row" };
const _hoisted_49 = { class: "col-sm" };
const _hoisted_50 = ["id", "onUpdate:modelValue"];
const _hoisted_51 = { class: "form-group card-metrics" };
const _hoisted_52 = { class: "row d-flex align-items-center" };
const _hoisted_53 = { class: "col-10" };
const _hoisted_54 = { class: "row" };
const _hoisted_55 = { class: "col-sm" };
const _hoisted_56 = ["id", "onUpdate:modelValue"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    const _component_assistant_selector = _resolveComponent("assistant-selector");
    const _component_VoiceSelector = _resolveComponent("VoiceSelector");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "control-label",
                for: "question_text"
            }, "Question Text", -1)),
            _createVNode(_component_QuillEditor, {
                content: $data.content.question.text,
                "onUpdate:content": _cache[0] || (_cache[0] = ($event) => (($data.content.question.text) = $event)),
                contentType: 'html',
                modules: _ctx.editorModules,
                toolbar: $data.toolbarOpts,
                theme: "snow"
            }, null, 8, ["content", "modules", "toolbar"])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
                class: "control-label",
                for: "question-text-classes"
            }, "Question Text CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "question-text-classes",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.content.questionTextClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.questionTextClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "control-label",
                for: "question-text-classes"
            }, "User Input CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "question-text-classes",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.content.userInputClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.userInputClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "control-label" }, "Question Image", -1)),
            _createElementVNode("div", _hoisted_6, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "input-group-prepend" }, [
                    _createElementVNode("a", {
                        class: "btn btn-primary text-white",
                        "data-input": "question-image",
                        "data-lfm": "image"
                    }, [
                        _createElementVNode("i", { class: "fa fa-image" })
                    ])
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                    id: "question-image",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.content.questionImage) = $event)),
                    class: "form-control",
                    type: "text"
                }, null, 512), [
                    [_vModelText, $data.content.questionImage]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _cache[14] || (_cache[14] = _createElementVNode("label", {
                class: "control-label",
                for: "compare-text-classes"
            }, "Compare Text CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "compare-text-classes",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.content.compareTextClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.compareTextClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
                class: "control-label",
                for: "ideal-text-classes"
            }, "Ideal Response CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "ideal-text-classes",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.content.idealResponseClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.idealResponseClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                        id: "stt",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($data.content.stt) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.stt]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                        class: "control-label",
                        for: "stt"
                    }, "Enable Speech to Text", -1))
                ])
            ])
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", null, [
            _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event) => ($options.addAssistant()))
            }, "Add Assistant")
        ]),
        ($data.content.assistants.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.assistants, (assistant, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "list-group-item"
                    }, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                (assistant.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: assistant.image,
                                        alt: "",
                                        class: "img-thumbnail mb-2"
                                    }, null, 8, _hoisted_15))
                                    : _createCommentVNode("", true),
                                _createElementVNode("label", {
                                    for: `assistant-image-${index}`,
                                    class: "control-label"
                                }, "Assistant Image", 8, _hoisted_16),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("a", {
                                            "data-input": `assistant-image-${index}`,
                                            class: "btn btn-primary text-white",
                                            "data-lfm": "image"
                                        }, _cache[17] || (_cache[17] = [
                                            _createElementVNode("i", { class: "fa fa-image" }, null, -1)
                                        ]), 8, _hoisted_19)
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        id: `assistant-image-${index}`,
                                        "onUpdate:modelValue": ($event) => ((assistant.image) = $event),
                                        class: "form-control",
                                        type: "text"
                                    }, null, 8, _hoisted_20), [
                                        [_vModelText, assistant.image]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: `tts-${index}`,
                                        "onUpdate:modelValue": ($event) => ((assistant.tts) = $event),
                                        type: "checkbox"
                                    }, null, 8, _hoisted_22), [
                                        [_vModelCheckbox, assistant.tts]
                                    ]),
                                    _createElementVNode("label", {
                                        for: `tts-${index}`,
                                        class: "ml-1"
                                    }, "Enable Text to Speech", 8, _hoisted_23)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("label", {
                                    for: `assistant-label-${index}`,
                                    class: "control-label"
                                }, "Assistant Label", 8, _hoisted_25),
                                _withDirectives(_createElementVNode("input", {
                                    id: `assistant-label-${index}`,
                                    "onUpdate:modelValue": ($event) => ((assistant.label) = $event),
                                    class: "form-control mb-4",
                                    type: "text"
                                }, null, 8, _hoisted_26), [
                                    [_vModelText, assistant.label]
                                ]),
                                _createVNode(_component_assistant_selector, {
                                    id: assistant.id,
                                    idIndex: index + 1,
                                    type: 'feedback',
                                    onHandleChange: ($event) => (assistant.id = $event)
                                }, null, 8, ["id", "idIndex", "onHandleChange"]),
                                (assistant.tts)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("label", {
                                            for: `voice-${index}`,
                                            class: "sr-only"
                                        }, "Voice", 8, _hoisted_28),
                                        _createVNode(_component_VoiceSelector, {
                                            id: assistant.voice,
                                            speed: assistant.speed,
                                            "model-id": assistant.opts?.modelId,
                                            stability: assistant.opts?.stability,
                                            "similarity-boost": assistant.opts?.similarityBoost,
                                            "style-exaggeration": assistant.opts?.styleExaggeration,
                                            "use-speaker-boost": assistant.opts?.useSpeakerBoost,
                                            "id-index": index,
                                            onHandleVoiceChange: ($event) => ($options.handleVoiceChange($event, index))
                                        }, null, 8, ["id", "speed", "model-id", "stability", "similarity-boost", "style-exaggeration", "use-speaker-boost", "id-index", "onHandleVoiceChange"])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("label", {
                                    for: `assistant-prompt-${index}`,
                                    class: "control-label"
                                }, "Feedback Prompt", 8, _hoisted_29),
                                _withDirectives(_createElementVNode("textarea", {
                                    id: `assistant-prompt-${index}`,
                                    "onUpdate:modelValue": ($event) => ((assistant.prompt) = $event),
                                    class: "form-control mb-4",
                                    style: { "height": "200px" }
                                }, null, 8, _hoisted_30), [
                                    [_vModelText, assistant.prompt]
                                ])
                            ])
                        ]),
                        _createElementVNode("button", {
                            class: "btn btn-danger position-absolute btn-remove",
                            type: "button",
                            onClick: ($event) => ($options.removeAssistant(index))
                        }, _cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_31)
                    ]));
                }), 128))
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "control-label" }, "Scoring Assistant Prompt", -1)),
            _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($data.content.question.promptScoringAssistant) = $event)),
                class: "form-control",
                style: { "height": "200px" }
            }, null, 512), [
                [_vModelText, $data.content.question.promptScoringAssistant]
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("small", { class: "form-text text-muted" }, "Provide detailed instructions on how you'd like the AI to evaluate a user's input and assign each meter a score of poor, satisfactory, good, or excellent.", -1))
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("p", { class: "font-weight-bold mb-0" }, "AI Grade Meter Effects"),
            _createElementVNode("small", { class: "form-text text-muted" }, "The AI will grade a user's response as poor, satisfactory, good, or excellent. Assign values to meters at each grade level to control how each grade will effect a user's score.")
        ], -1)),
        _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Poor", -1)),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.poorMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_38), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Satisfactory", -1)),
                _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.satisfactoryMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_44), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Good", -1)),
                _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.goodMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_50), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Excellent", -1)),
                _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.excellentMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_56), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ])
    ]));
}
